import { Browser } from "@capacitor/browser";
import { WorkerRequirementStatus } from "@clipboard-health/contract-worker-app-bff";
import { CbhIcon, Divider, Image, Text } from "@clipboard-health/ui-components";
import { ButtonBase, Stack } from "@mui/material";
import { logEvent } from "@src/appV2/lib/analytics";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib/analytics/events";
import clipboardIllustration from "@src/appV2/lib/assets/images/clipboard-illustration.png";
import { Button } from "@src/appV2/redesign/components/Button";

import { ActionBannerIconWrapper } from "../../ActionBannerIconWrapper";
import { DocumentDetailsBannerWithAction } from "../../BannerWithAction";
import { DocumentDetailsStatusCard } from "../../StatusCard";
import { useRequirementDetailsContext } from "../../useRequirementDetailsContext";

export const BLS_CPR_CERTIFICATION_URL = "https://freecprcertification.org";

export function BlsCprCertificationStatusCard() {
  const { requirement: workerRequirement } = useRequirementDetailsContext();
  const { requirementId } = workerRequirement;
  const { expiry, status } = workerRequirement;

  const handleCtaClick = async () => {
    logEvent(APP_V2_USER_EVENTS.CLICKED_CTA_ON_IMPROVED_BLS_CPR_BUTTON, {
      requirement_id: requirementId,
      status,
    });
    await Browser.open({
      url: BLS_CPR_CERTIFICATION_URL,
    });
  };

  return status === WorkerRequirementStatus.EXPIRING ||
    status === WorkerRequirementStatus.MISSING ? (
    <DocumentDetailsBannerWithAction
      variant={status}
      expiryDate={expiry ? new Date(expiry) : undefined}
      header="Get BLS/CPR certified online for free in under 10 minutes"
      button={
        <Button
          invert
          variant="contained"
          size="small"
          sx={{ alignSelf: "flex-start" }}
          onClick={handleCtaClick}
        >
          Get certified
        </Button>
      }
      illustration={<Image width={104} src={clipboardIllustration} alt="Clipboard Illustration" />}
    />
  ) : (
    <DocumentDetailsStatusCard
      footer={
        status === WorkerRequirementStatus.REJECTED ||
        status === WorkerRequirementStatus.EXPIRED ? (
          <Stack direction="column" spacing={5}>
            <Divider />
            <ButtonBase sx={{ textAlign: "left" }} onClick={handleCtaClick}>
              <Stack
                direction="row"
                alignItems="center"
                spacing={2}
                justifyContent="space-between"
                sx={{ width: "100%" }}
              >
                <Stack direction="row" spacing={3} alignItems="center">
                  <ActionBannerIconWrapper
                    imageSource={clipboardIllustration}
                    imageAlt="Clipboard Illustration"
                  />
                  <Text semibold variant="body1">
                    Get BLS/CPR certified online for free in under 10 minutes
                  </Text>
                </Stack>
                <CbhIcon size="small" type="chevron-right" />
              </Stack>
            </ButtonBase>
          </Stack>
        ) : null
      }
    />
  );
}
